module.exports = __webpack_public_path__ + "img/BANNERS_BIG-03.f3609a17.jpg";